module.exports = __webpack_public_path__ + "assets/img/771587008153_.pic_hd.555314dc.jpg";